/* eslint-disable camelcase */
const getAccessToken = async oktaAuth => {
  const { accessToken } = await oktaAuth.tokenManager.getTokens();

  return accessToken && accessToken.accessToken;
};

const getIdToken = async oktaAuth => {
  const { idToken } = await oktaAuth.tokenManager.getTokens();

  return idToken && idToken.idToken;
};

const getAnalyticsObj = async oktaAuth => {
  const accessToken = await oktaAuth.getAccessToken();
  const { payload } = await oktaAuth.token.decode(accessToken);

  return {
    oktaID: payload.uid,
    groups: payload.groups
  };
};

const getUser = async oktaAuth => {
  const accessToken = await oktaAuth.getAccessToken();
  const { payload } = await oktaAuth.token.decode(accessToken);

  return {
    email: payload.sub,
    family_name: payload.lastname,
    given_name: payload.firstname,
    name: `${payload.firstname} ${payload.lastname}`,
    preferred_username: payload.sub,
    uid: payload.uid
  };
};

export { getAccessToken, getAnalyticsObj, getIdToken, getUser };
